import UtilityService from "../../../../../../services/UtilityService";

export function formatAmount(val) {
	if (val === 0 || val == null) return "—";
	let abs = Math.abs(val).toLocaleString("en-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
	return val < 0 ? "(" + abs + ")" : abs;
}

export function formatDate(yearEnd) {
	if (!yearEnd) return "";
	let parsed = parseLocalDate(yearEnd);
	return parsed.toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" });
}

export function parseLocalDate(isoDate) {
	const localDate = UtilityService.parseLocalDate(isoDate);
	return localDate;
}

export function formatDrillAmount(val) {
	if (val == null) return "—";
	let abs = Math.abs(val).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	return val < 0 ? "(" + abs + ")" : abs;
}

export function formatDrillDate(d) {
	if (!d) return "—";
	try { return new Date(d).toLocaleDateString("en-CA", { month: "short", day: "numeric" }); }
	catch (e) { return String(d); }
}

export function formatReportAmount(val) {
	if (val == null || val === 0) return "–";
	return Math.abs(val).toLocaleString("en-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function formatCurrency(val) {
	if (val == null || val === 0) return "–";
	return "$" + Math.abs(val).toLocaleString("en-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function fmtBal(val) {
	if (val == null || val === 0) return "—";
	const formattedBalance = UtilityService.formatDollarBalance({ balance: val, decimalPlaces: 0 });
	return formattedBalance;
}
